export const cancelContent = {
  bullets: [
    'Access to your plan benefits will end. You can resubscribe anytime to restore them.',
    "You won't be able to register new works.",
    'Any outstanding balance must be paid in full before you can resubscribe.',
  ],
  confirmBody:
    'By continuing, I understand that my membership will be cancelled and will not renew. On Pro Bundle, my registrations will be deactivated and I will no longer have access to them; on Pro Membership, my registrations remain accessible, and I will no longer be able to register new works once my membership ends. I further acknowledge that cancellation does not relieve me of fees that may continue to accrue on my account (as applicable), and that any such fees remain my responsibility under the Terms.',
  success: {
    title: 'Your subscription is being cancelled',
    body: "You'll receive an email once cancellation is complete, and an invoice for any balance paid.",
  },
}
